import { CommonDialogProps, DialogConfig } from '../common/types'
import { SandboxDialogContentContainer } from './SandboxDialogContentContainer'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

export type SandboxDialogProps = { asDrawer?: boolean } & CommonDialogProps

function SandboxDialog({ open, setOpen, asDrawer = false }: SandboxDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent contentVerticalPosition={asDrawer ? 'bottom' : 'center'}>
        <SandboxDialogContentContainer closeDialog={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  )
}

export const sandboxDialogConfig: DialogConfig<SandboxDialogProps> = {
  options: {
    closeOnAccountChange: false,
  },
  element: SandboxDialog,
  name: 'SandboxDialog',
}
